import { BaseApi } from '@/core/api/base.api'
import {RoomCall} from "@/core/api/room.call.api";
import _ from 'lodash'
import {Room} from "@/core/api/room.api";
import {RoomLogWorker} from "@/lib/gooroomee/log/room-log-worker";

class RoomCallLogApi extends BaseApi {

  constructor() {
    super()
    RoomCall.Log = this

    if(process.env.NODE_ENV === 'production') {
      Room.ready(async e => {
        RoomLogWorker.start({
          roomData: Room.getRoomData(),
          serverUrl: this.getLogServerUrl() + '/ws/log'
        })
      });
    }
  }

  getLogServerUrl() {
    return process.env.VUE_APP_CALL_LOG_URL
        || process.env.VUE_APP_WS_URL
        || '';
  }

  getLogMonitorUrl() {
    let room = Room.getRoomData().room;
    let url = this.getLogServerUrl() + `/monitor/room?roomId=${room.roomId}&roomTitle=${room.roomTitle}`;
    return url;
  }

  sendPeerStatsLog(logData) {
    RoomLogWorker.sendMessage('sendPeerStatsLog', logData);
  }
}


export const RoomCallLog = new RoomCallLogApi()
